import { Component, Input, OnInit } from '@angular/core';
import { AppMessage } from 'src/app/models/app-message';

@Component({
  selector: 'app-terms-details',
  templateUrl: './terms-details.component.html',
  styleUrls: ['./terms-details.component.css']
})
export class TermsDetailsComponent implements OnInit {
  @Input() data:AppMessage;
  
  constructor() { }

  ngOnInit(): void {
  }

}
